<template>
  <b-button @click="saveClick" :disabled="saveDisabled">
    <b-icon-cloud-upload aria-hidden="true"></b-icon-cloud-upload>
    Save
    <b-modal
        id="modal-save-title"
        title="Save Design"
        v-model="modalShow"
        @ok="saveDesign">
      <p class="my-4">Your design has no name yet. It's optional, but recommended.</p>

      <b-form @submit.prevent="noop">
        <b-form-group
            id="input-group-name"
            label="Give it a name:"
            label-for="input-1"
            description="optional">
          <b-form-input
              id="name"
              v-model="design.name"
              placeholder="Untitled design"></b-form-input>
        </b-form-group>
      </b-form>

      <template v-slot:modal-ok>
          <b-icon-cloud-upload aria-hidden="true"></b-icon-cloud-upload>
          Save
      </template>
    </b-modal>
  </b-button>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { BIconCloudUpload } from 'bootstrap-vue';

import SaveMixin from '@/mixins/SaveMixin';

const equal = require('fast-deep-equal');

export default {
  name: 'SaveDesign',
  components: {
    BIconCloudUpload,
  },
  mixins: [SaveMixin],
  props: {
    // msg: String,
  },
  data() {
    return {
      modalShow: false,
    };
  },
  computed: {
    saveDisabled() {
      return !this.leadDesign.image.key || !this.designChanged;
    },
    designChanged() {
      // console.log('designChanged:', this.design, this.lastSavedDesigns);
      const changed = !equal(this.designs, this.lastSavedDesigns);
      // console.log('designChanged ->', changed);
      return changed;
    },
    ...mapState(['designs', 'lastSavedDesigns']),
    ...mapGetters(['design', 'leadDesign']),
  },
  methods: {
    noop() {
      console.log('noop');
    },
    saveClick() {
      console.log('saveClick');
      if (!this.design.name) {
        console.log('unnamed; launch dialog');
        this.modalShow = true;
      } else {
        this.saveDesign();
      }
    },
    // saveDesign() ... from mixin
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
